import { AutoComplete } from "antd";
import { useIntl } from "react-intl";

import { useDiscountCodeSelect } from "./hooks";
import { DiscountCodeSelectProps } from "./types";

const DiscountCodeSelect: React.FC<DiscountCodeSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const eventSelect = useDiscountCodeSelect({ value, onChange });

  return (
    <AutoComplete
      {...eventSelect}
      placeholder={intl.formatMessage({
        defaultMessage: "Choose Discount Code",
      })}
      {...props}
    />
  );
};

export default DiscountCodeSelect;
